var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"gutter":30}},[_c('el-col',{attrs:{"xl":12}},[_vm._t("default")],2),_c('el-col',{staticClass:"mb-xs-3",attrs:{"xl":12}},[_c('video-player',{attrs:{"height":_vm.height,"video-name":_vm.videoName,"muted":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }